import $ from 'jquery';

class Join {
    constructor($wrapper) {
        this.$form = $wrapper.find('.join-form-wrapper');
        this.$emailForm = $wrapper.find('#email-form');

        if (this.$form.length && this.$emailForm.length) {
            this.init();
            this.events();
        }
    }

    redirect(url) {
        setTimeout(function() {
            window.location = url;
            $('meta[http-equiv="refresh"]').attr('content', '10; url=' + url);
        }, 0);
    }

    init() {
        this.MSG = {
            'invalid-phone': 'This is not a valid phone number.',
            'invalid-email': 'This is not a valid email address.',
            'email-failed': 'An error occured and mail hasn’t been sent.',
            'sms-failed': 'An error occured and SMS hasn’t been sent.'
        };

        this.$target = this.$form.find('.target');
        this.$message = this.$form.find('.msg');
        this.$submit = this.$form.find('.submit');
        this.$reset = this.$form.find('.back');
        this.$sentTo = this.$form.find('.thank-you .sent-to');

        this.$email = this.$emailForm.find('.email');

        this.smsAction = 'https://pawscout.com/wp-content/themes/pawscout/send-sms.php';
    }

    events() {
        this.$target.on('keyup', this.checkField.bind(this));

        this.$emailForm.on('submit', e => {
            e.preventDefault();

            $.ajax(this.$emailForm.attr('action'), {
                method: 'POST',
                data: this.$emailForm.serialize()
            })
                .done(data => {
                    switch (data.status) {
                    case 'mail_sent':
                        this.thankYou(true);
                        break;
                    case 'validation_failed':
                        this.$target.closest('.form-field').addClass('error');
                        this.$message.text(data.invalidFields[0].message);
                        break;
                    default:
                    }
                })
                .fail(() => {
                    this.$message.text(this.MSG['email-failed']);
                })
                .always(() => {
                    this.loader(false);
                });
        });

        /* email form handling */
        this.$emailForm
            .on('wpcf7mailsent', () => {
                this.thankYou(true);
            });

        this.$submit.on('click', e => {
            e.preventDefault();

            let val = this.$target.val();

            if (val) {
                this.loader(true);

                if (this.isEmail(val)) {
                    this.sendEmail(val);
                } else {
                    this.sendSMS(val);
                }
            }
        });

        this.$reset.on('click', e => {
            e.preventDefault();

            this.thankYou(false);
        });
    }

    isEmail(val) {
        return /\D+/gi.test(val.replace(/[^a-zA-Z\d]/gi, ''));
    }

    isPhone(val) {
        let r = /[a-z]/gi;

        if (r.test(val) === true)
            return false;

        r = /[0-9.\-\s()]*$/gi;

        return r.test(val);
    }

    validatePhone(val) {
        let r = /[a-z]/gi;

        if (r.test(val) === true)
            return false;

        r = /[0-9.\-\s()]{10,18}$/gi;

        return r.test(val);
    }

    checkField() {
        let val = this.$target.val();

        if (val.length < 4) {
            this.$target.removeClass('is-phone is-email');
            this.$target.closest('.form-field').removeClass('error');
            this.$submit.attr('disabled', 'disabled');
        } else {
            if (this.isEmail(val)) {
                this.$target.addClass('is-email').removeClass('is-phone');
            } else {
                this.$target.removeClass('is-email').toggleClass('is-phone', this.isPhone(val));
            }

            this.$submit.removeAttr('disabled');
        }
    }

    sendEmail(val) {
        this.$emailForm.find('.email').val(val);
        this.$emailForm.submit();
    }

    sendSMS(val) {
        // if (this.validatePhone(val)) {
        grecaptcha.ready(() => {
            grecaptcha.execute('6LdFA9wUAAAAAMpgxOlT7Qxb5bM8PfYe0_36SPCj', {action: 'submit'})
                .then((token) => {
                    $.post(this.smsAction, {phone: val, token: token})
                        .done(data => {
                            if (data && data.sent) {
                                this.thankYou(true);
                            } else {
                                this.$message.text(this.MSG['sms-failed']);
                            }
                        })
                        .fail(data => {
                            this.$target.closest('.form-field').addClass('error');
                            this.$message.text(data.responseJSON.error || this.MSG['invalid-phone']);
                        })
                        .always(() => {
                            this.loader(false);
                        });
                });
        });
        // }
    }

    loader(show) {
        this.$form.toggleClass('loading', show);
    }

    thankYou(show) {
        if (show) {
            this.$sentTo.text(this.$target.val());
        } else {
            this.$target.val('').closest('.form-field').removeClass('error');
        }
        this.$form.toggleClass('done', show);
    }
}

export default Join;
